import type { StoreState } from "./types";
import { merge } from "lodash-es";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export const localStorageKey = "axiom-global-store";

export const useGlobalStore = create<StoreState>()(
  persist(
    (): StoreState => ({
      user: null,
      selectedTeam: null
    }),
    {
      name: localStorageKey,
      merge: (persistedState, currentState) => merge(currentState, persistedState)
    }
  )
);

export const useUserStore = () => useGlobalStore(state => state.user);

export const useSelectedTeam = () => useGlobalStore(state => state.selectedTeam);
